import { isNullOrUndefined } from 'utils/object/object.utils';

export function isGroundFloor(floor?: number): boolean | null {
  return isNullOrUndefined(floor) ? null : floor === 0;
}
